import React, { useState } from "react";
import api, { apiErr } from "@/lib/api";

// Support contact form (public /support page and Account page).
export const SupportForm = ({ defaultName = "", defaultEmail = "", idPrefix = "support" }) => {
  const [f, setF] = useState({ name: defaultName, email: defaultEmail, message: "" });
  const [state, setState] = useState({ busy: false, done: null, error: null });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setState({ busy: true, done: null, error: null });
    try {
      await api.post("/support/contact", f);
      setState({ busy: false, done: "Thanks — we received your message and will reply by email.", error: null });
      setF({ ...f, message: "" });
    } catch (err) { setState({ busy: false, done: null, error: apiErr(err) }); }
  };
  const input = "w-full rounded-lg bg-white/5 border border-white/10 px-3 py-2 text-sm text-tc-txt focus:outline-none focus:border-tc-coach";
  return (
    <form onSubmit={submit} className="space-y-3" data-testid={`${idPrefix}-form`}>
      <input data-testid={`${idPrefix}-name`} className={input} placeholder="Your name" value={f.name} onChange={set("name")} required maxLength={120} />
      <input data-testid={`${idPrefix}-email`} className={input} type="email" placeholder="Your email" value={f.email} onChange={set("email")} required maxLength={200} />
      <textarea data-testid={`${idPrefix}-message`} className={`${input} min-h-[120px]`} placeholder="How can we help?" value={f.message} onChange={set("message")} required minLength={5} maxLength={4000} />
      <button data-testid={`${idPrefix}-submit`} disabled={state.busy} className="rounded-lg bg-tc-coach text-tc-bg font-semibold px-4 py-2 text-sm disabled:opacity-50">{state.busy ? "Sending…" : "Send message"}</button>
      {state.done && <p data-testid={`${idPrefix}-success`} className="text-sm text-tc-bull">{state.done}</p>}
      {state.error && <p data-testid={`${idPrefix}-error`} className="text-sm text-tc-bear">{state.error}</p>}
    </form>
  );
};
